export default __webpack_public_path__ + "static/media/Artboard–1.33270da7.png";